"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoggedInUserInfo = exports.getAuthenticationStatus = exports.isInternalUser = exports.isLoggedIn = void 0;

var _constants = _interopRequireDefault(require("./constants"));

var script = document.createElement('script');
script.type = 'text/javascript';
script.src = '//assets.homedepot-static.com/core/thd-customer/v4.12.1/thd-customer.js';
document.getElementsByTagName('head')[0].appendChild(script);

var getCookie = function getCookie(cname) {
  var name = "".concat(cname, "=");
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  var found = ca.find(function (element) {
    return element.startsWith(name) || element.startsWith(" ".concat(name));
  });

  if (found && found.length > 0) {
    found = found.trim().substring(name.length, found.length);
    if (found.startsWith('"')) found = found.substring(1);
    if (found.endsWith('"')) found = found.substring(0, found.length - 1);
    return found;
  }

  return '';
};

var cookieExists = function cookieExists(cookieName) {
  var cookieValue = getCookie(cookieName) || '';
  return cookieValue.length > 0;
};

var isLoggedIn = function isLoggedIn() {
  if (window.THDCustomer) {
    var loggedInStatus = window.THDCustomer["default"].isLoggedIn;
    return loggedInStatus;
  }

  return null;
};

exports.isLoggedIn = isLoggedIn;

var isInternalUser = function isInternalUser() {
  return cookieExists(_constants["default"].CookieNames.InternalUser);
}; // eslint-disable-next-line max-len


exports.isInternalUser = isInternalUser;

var getAuthenticationStatus = function getAuthenticationStatus() {
  return isLoggedIn() ? _constants["default"].AuthenticationStatuses.Authenticated : _constants["default"].AuthenticationStatuses.Guest;
};

exports.getAuthenticationStatus = getAuthenticationStatus;

var getLoggedInUserInfo = function getLoggedInUserInfo() {
  if (window.THDCustomer) {
    var _window$THDCustomer$d = window.THDCustomer["default"],
        email = _window$THDCustomer$d.email,
        svocID = _window$THDCustomer$d.svocID;
    return {
      identityId: svocID,
      email: email
    };
  }

  return {};
};

exports.getLoggedInUserInfo = getLoggedInUserInfo;
//# sourceMappingURL=thdUserInfo.js.map